// Carga de archivos
export const ACTUALIZAR_ATRIBUTOS_ARCHIVOS = 'ACTUALIZAR_ATRIBUTOS_ARCHIVOS';
export const ARCHIVOS_SELECCIONADOS = 'ARCHIVOS_SELECCIONADOS';
export const ELIMINAR_ARCHIVO = 'ELIMINAR_ARCHIVO';
export const INICIALIZAR_BARRAS_PROCESO = 'INICIALIZAR_BARRAS_PROCESO';
export const ACTUALIZAR_BARRA_PROCESO = 'ACTUALIZAR_BARRA_PROCESO';
export const ACTUALIZAR_INFORMACION_ARCHIVOS = 'ACTUALIZAR_INFORMACION_ARCHIVO';
export const SINCRONIZAR_INFORMACION_ARCHIVOS =
    'SINCRONIZAR_INFORMACION_ARCHIVOS';
export const SET_MOSTRAR_PROCESAR_INTERNACION =
    'SET_MOSTRAR_PROCESAR_INTERNACION';
export const SET_CARGA_ARCHIVOS_INTERNACION = 'SET_CARGA_ARCHIVOS_INTERNACION';
export const VACIAR_ARCHIVOS_SUBIDOS = 'VACIAR_ARCHIVOS_SUBIDOS';
export const SUMAR_RESPUESTA = 'SUMAR_RESPUESTA';
// Presentacion
export const ACTUALIZAR_FACTURA_FILE = 'ACTUALIZAR_FACTURA_FILE';
export const ACTUALIZAR_IMAGENES_FILES = 'ACTUALIZAR_IMAGENES_FILES';
export const ACTUALIZAR_LIQUIDACIONES_FILES = 'ACTUALIZAR_LIQUIDACIONES_FILES';
export const ACTUALIZAR_INTERNACIONES = 'ACTUALIZAR_INTERNACIONES';
export const ACTUALIZAR_NRO_INTERNACION = 'ACTUALIZAR_NRO_INTERNACION';
export const AGREGAR_INTERNACION = 'AGREGAR_INTERNACION';
export const CARGAR_DATOS_PRESENTACION = 'CARGAR_DATOS_PRESENTACION';
export const INICIALIZAR_NUEVA_PRESENTACION = 'INICIALIZAR_NUEVA_PRESENTACION';
export const ACTUALIZAR_ERRORES_PRESENTACION =
    'ACTUALIZAR_ERRORES_PRESENTACION';
export const REINICIAR_ERRORES_PRESENTACION = 'REINICIAR_ERRORES_PRESENTACION';
export const ACTUALIZAR_ATRIBUTO_PRESENTACION =
    'ACTUALIZAR_ATRIBUTO_PRESENTACION';
export const ACTUALIZAR_PRESTACIONES_FILES = 'ACTUALIZAR_PRESTACIONES_FILES';
// Internaciones
export const RECUPERAR_INFO_NRO_INTERNACION = 'RECUPERAR_INFO_NRO_INTERNACION';
export const ACTUALIZAR_INFO_NRO_INTERNACION =
    'ACTUALIZAR_INFO_NRO_INTERNACION';
export const REINICIAR_DATOS_INTERNACION = 'REINICIAR_DATOS_INTERNACION';
export const ACTUALIZAR_NUEVA_INTERNACION = 'ACTUALIZAR_NUEVA_INTERNACION';
export const ACTUALIZAR_INTERNACION = 'ACTUALIZAR_INTERNACION';
export const GUARDAR_TEMP_ID = 'GUARDAR_TEMP_ID';
export const AGREGAR_ARCHIVO_NUEVA_INTERNACION =
    'AGREGAR_ARCHIVO_NUEVA_INTERNACION';
export const INTERNACION_PARA_ACTUALIZAR = 'INTERNACION_PARA_ACTUALIZAR';
export const RESET_INTERNACION_PARA_ACTUALIZAR =
    'RESET_INTERNACION_PARA_ACTUALIZAR';

// Grilla Principal
export const GET_PRESENTACIONES = 'GET_PRESENTACIONES';
export const SET_PRESENTACIONES = 'SET_PRESENTACIONES';
export const SET_FILTRO_GRILLA = 'SET_FILTRO_GRILLA';
export const SET_ESTADOS_FILTRO = 'SET_ESTADOS_FILTRO';
export const ACTUALIZAR_ATRIBUTOS_GRILLA = 'ACTUALIZAR_ATRIBUTOS_GRILLA';

// Auth
export const SET_PRESTADOR_ACTIVO = 'SET_PRESTADOR_ACTIVO';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_ALERTA_PRESTADOR = 'SET_ALERTA_PRESTADOR';

// Ventana Dialogo
export const ACTUALIZAR_ATRIBUTOS_VENTANA = 'ACTUALIZAR_ATRIBUTOS_VENTANA';

// Snack Mensaje
export const ACTUALIZAR_ATRIBUTOS_SNACK = 'ACTUALIZAR_ATRIBUTOS_SNACK';
